// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navDrawer .sidePadding{padding:0 .5rem}`, "",{"version":3,"sources":["webpack://./components/OmniBarNavigation/OmniBarNavigation.scss"],"names":[],"mappings":"AACI,wBACI,eAAA","sourcesContent":[".navDrawer {\n    .sidePadding {\n        padding: 0 0.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
